import { render } from "./OrganisationReportUsers.vue?vue&type=template&id=9f33a256"
import script from "./OrganisationReportUsers.vue?vue&type=script&lang=js"
export * from "./OrganisationReportUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__